<script>
import cloneDeep from "lodash/cloneDeep";
import isEqual from "lodash/isEqual";

export default {
  name: "popupMultiple",
  components: {},
  props: {
    //是否开启搜索
    search: {
      type: Boolean,
      default: false
    },
    //搜索 过滤参数
    searchFilter: {
      type: [String, Array, Function],
      default: () => ["text", "simpleCode"]
    },
    //搜索框 提示文字
    searchPlaceholder: {
      type: String,
      default: ""
    },
    //显示隐藏
    visible: {
      type: Boolean,
      default: false
    },
    //值
    value: {
      type: Array,
      default: () => []
    },
    //数据
    options: {
      type: Array,
      default: () => []
    },
    //数据value 参数
    valueField: {
      type: String,
      default: "id"
    },
    //数据text 参数
    labelField: {
      type: String,
      default: "name"
    },
    //禁用value 参数
    disabledField: {
      type: String,
      default: "disabled"
    },
    //确认描述
    confirmButtonText: {
      type: String,
      default: "确认"
    },
    //取消描述
    cancelButtonText: {
      type: String,
      default: "取消"
    },
    //最大数量
    max: {
      type: [String, Number],
      default: null
    },
    //最大数量 提示
    maxPlaceholder: {
      type: String,
      default: "最大选择数量:"
    },
    //高度
    height: {
      type: String,
      default: "60vh"
    },
    //挂载dom
    getContainer: {
      type: String,
      default: "#app"
    },
    //点击遮罩层是否关闭
    closeOnClickOverlay: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      realValue: [],
      defaultColumns: [],
      visibleColumns: [],
      searchValue: ""
    };
  },
  model: {
    prop: "visible"
  },
  watch: {
    visible() {
      this.searchValue = "";
      this.initData();
    },
    options() {
      this.initData();
    },
    value(e) {
      if (!isEqual(this.realValue, e)) {
        this.realValue = e;
        this.initData();
      }
    }
  },
  computed: {},
  created() {
    this.initData();
  },
  methods: {
    /**
     * @description: 初始化
     * @param {*}
     * @return {*}
     */
    initData() {
      let { value, valueField } = this;
      let defaultColumns = cloneDeep(this.options);
      let realValue = [];
      defaultColumns.map(p => {
        p.isChecked = value && value.includes(p[valueField]);
        if (p.isChecked) realValue.push(p[valueField]);
      });
      this.defaultColumns = defaultColumns;
      this.visibleColumns = defaultColumns;
      this.realValue = realValue;
    },
    /**
     * @description: 搜索
     * @param {*}
     * @return {*}
     */
    onSearch() {
      let that = this;
      that.$nextTick(() => {
        let { searchValue, searchFilter, defaultColumns } = that;
        if (searchValue && searchFilter) {
          if (typeof searchFilter == "string") {
            that.visibleColumns = defaultColumns.filter(p => {
              return (
                p[searchFilter] &&
                p[searchFilter]
                  .toString()
                  .toLowerCase()
                  .indexOf(searchValue.toLowerCase()) > -1
              );
            });
          } else if (searchFilter instanceof Array) {
            that.visibleColumns = defaultColumns.filter(p => {
              return searchFilter.find(
                o =>
                  p[o] &&
                  p[o]
                    .toString()
                    .toLowerCase()
                    .indexOf(searchValue.toLowerCase()) > -1
              );
            });
          } else {
            that.visibleColumns = defaultColumns.filter(p => searchFilter(p));
          }
        } else {
          that.visibleColumns = defaultColumns;
        }
      });
    },
    /**
     * @description: 选中
     * @param {*} row
     * @return {*}
     */
    checked(row) {
      let { max, disabledField } = this;
      if (row[disabledField]) return false;
      if (max && !row.isChecked) {
        let len = 0;
        this.visibleColumns.map(p => {
          if (p.isChecked) {
            len++;
          }
        });
        if (max <= len) {
          this.$notify({ type: "danger", message: this.maxPlaceholder + max });
          return false;
        }
      }
      row.isChecked = !row.isChecked;
    },
    /**
     * @description: 获取
     * @param {*}
     * @return {*}
     */
    getValue() {
      let { valueField } = this;
      let value = [];
      this.defaultColumns.forEach(p => {
        if (p.isChecked) {
          value.push(p[valueField]);
        }
      });
      return value;
    },
    /**
     * @description: 确认
     * @param {*}
     * @return {*}
     */
    confirm() {
      let value = this.getValue();
      this.$emit("input", false);
      this.$emit("update:value", value);
      this.$emit("confirm", value);
    },
    /**
     * @description: 取消
     * @param {*}
     * @return {*}
     */
    cancel(e) {
      this.$emit("input", false);
      this.$emit("cancel", e);
    },
    /**
     * @description: popup 渲染
     * @param {*}
     * @return {*}
     */
    popupRender() {
      const option = {
        props: {
          position: "bottom",
          value: this.visible,
          getContainer: this.getContainer,
          closeOnClickOverlay: this.closeOnClickOverlay
        },
        on: {
          input: val => {
            this.$emit("input", val);
          }
        }
      };
      return (
        <van-popup {...option}>
          {this.confirmRender()}
          {this.searchRender()}
          {this.multipleRender()}
        </van-popup>
      );
    },
    /**
     * @description: 搜索 渲染
     * @param {*}
     * @return {*}
     */
    searchRender() {
      let that = this;
      if (that.search) {
        return (
          <van-search
            {...{
              class: "search",
              props: {
                value: this.searchValue,
                placeholder: this.searchPlaceholder
              },
              on: {
                input: e => {
                  that.searchValue = e;
                  that.onSearch();
                }
              }
            }}
          />
        );
      }
    },
    /**
     * @description: 多选框 渲染
     * @param {*}
     * @return {*}
     */
    multipleRender() {
      return (
        <div
          {...{
            style: {
              maxHeight: `${this.height}`,
              overflow: "auto"
            }
          }}
        >
          <van-cell-group
            {...{
              class: "list"
            }}
          >
            {this.cellRender()}
          </van-cell-group>
        </div>
      );
    },
    /**
     * @description: cell 渲染
     * @param {*}
     * @return {*}
     */
    cellRender() {
      const { labelField, disabledField } = this;
      return this.visibleColumns.map(p => {
        let option = {
          class: { item: true, disabled: p[disabledField] },
          on: {
            click: () => this.checked(p)
          },
          scopedSlots: {
            title: () => {
              return (
                <div>
                  {p[labelField]}
                  {p.isChecked ? this.checkIconRender(p) : ""}
                </div>
              );
            }
          }
        };
        return <van-cell {...option} />;
      });
    },
    /**
     * @description: 选中图标 渲染
     * @param {*}
     * @return {*}
     */
    checkIconRender() {
      return <van-icon name="checked" class="icon-success" />;
    },
    /**
     * @description: 确认|取消 渲染
     * @param {*}
     * @return {*}
     */
    confirmRender() {
      return (
        <div class="select-head van-hairline--top-bottom van-picker__toolbar">
          <button class="van-picker__cancel" onClick={this.cancel}>
            {this.cancelButtonText}
          </button>
          <button class="van-picker__confirm" onClick={this.confirm}>
            {this.confirmButtonText}
          </button>
        </div>
      );
    }
  },
  render() {
    return this.popupRender();
  }
};
</script>

<style lang="less" scoped>
/deep/.search .van-cell__value {
  text-align: left;
  line-height: initial;
  .van-field__body {
    display: flex;
  }
}
.list {
  .item {
    position: relative;
    padding-right: 40px;
    .icon-success {
      position: absolute;
      right: 15px;
      top: 13px;
      color: @green;
      font-size: @fontSize20;
    }
    &.disabled {
      background: #f1f1f1;
    }
  }
}
</style>
